var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#132A4D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#132A4D",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8953_109769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 30a1.25 1.25 0 0 1-.884-2.133l17.5-17.5a1.25 1.25 0 1 1 1.768 1.767l-17.5 17.5a1.25 1.25 0 0 1-.884.366m6.25-16.25A3.755 3.755 0 0 0 13.75 10 3.755 3.755 0 0 0 10 13.75a3.755 3.755 0 0 0 3.75 3.75 3.755 3.755 0 0 0 3.75-3.75m-2.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m15 12.5a3.755 3.755 0 0 0-3.75-3.75 3.755 3.755 0 0 0-3.75 3.75A3.755 3.755 0 0 0 26.25 30 3.755 3.755 0 0 0 30 26.25m-2.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8953_109769"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h20v20H10z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.c98d15470d75f5303b03f1f3b7c209a0.svg";
export { ForwardRef as ReactComponent };